import Env from 'lib/env/Env';
import { OnlineStatusApi } from './online-status.api';

export function createOnlineStatusApi(): OnlineStatusApi {
  return {
    async checkHealth(signal) {
      const response = await fetch(`${Env.apiURL}/health`, { signal });
      if (!response.ok) {
        throw new Error(`Health check failed with status ${response.status}`);
      }
    }
  };
}
